/**
 * N10 — Fix dead "★★★★★ N reviews" link on PDP.
 * Bourbon Group — staged 2026-07-21. Fleet-wide (Total / Top / Rare).
 *
 * Problem: the Judge.me "preview_badge" app block (renders the star row +
 * "(N reviews)" near price/title) and the legacy Dawn `rating` block both
 * render as plain text/div — no href, no click handler, no scroll target.
 * The full Judge.me `review_widget` app block IS present lower on the same
 * PDP template (confirmed in product.json for all 3 stores) — it just isn't
 * wired to the badge above.
 *
 * Fix: delegated click-listener, no edits to the Judge.me app block itself
 * (app-block markup is app-hosted and out of theme scope). Finds the
 * already-rendered widget via Judge.me's public, stable CSS hooks and
 * smooth-scrolls/focuses it. No new vendor calls, no fabricated data.
 */
(function () {
  var HEADER_OFFSET = 120; // clears sticky header + sticky mobile ATC bar

  function getReviewWidget() {
    // Judge.me's stable public selectors, in priority order.
    return (
      document.querySelector('.jdgm-rev-widg__wrapper') ||
      document.querySelector('.jdgm-widget') ||
      document.querySelector('[id^="judgeme_product_reviews"]') ||
      document.querySelector('.jdgm-review-widget')
    );
  }

  function scrollToReviews(evt) {
    var widget = getReviewWidget();
    if (!widget) return; // nothing rendered (e.g. widget still loading) — do nothing, no dead-end error
    if (evt && evt.preventDefault) evt.preventDefault();
    var top = widget.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: top, behavior: 'smooth' });
    // move a11y focus without re-triggering scroll
    widget.setAttribute('tabindex', '-1');
    widget.focus({ preventScroll: true });
  }

  function onDocClick(e) {
    var trigger = e.target.closest(
      '.jdgm-prev-badge, .jdgm-star-rating, .rating, .rating-text, .rating-count, [data-pdp-review-anchor]'
    );
    if (!trigger) return;
    scrollToReviews(e);
  }

  document.addEventListener('click', onDocClick);

  // Make the trigger visually + semantically clickable (cursor, keyboard).
  function markInteractive() {
    document
      .querySelectorAll('.jdgm-prev-badge, .rating, .rating-text, .rating-count')
      .forEach(function (el) {
        el.style.cursor = 'pointer';
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        el.setAttribute('role', el.getAttribute('role') || 'button');
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Jump to reviews');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markInteractive);
  } else {
    markInteractive();
  }
  // Judge.me badge renders async — re-mark after it mounts.
  var mo = new MutationObserver(markInteractive);
  mo.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', function () {
    setTimeout(function () { mo.disconnect(); }, 6000); // stop observing after badge has had time to mount
  });

  // Keyboard support (Enter/Space) for the elements we just made focusable.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = e.target.closest(
      '.jdgm-prev-badge, .rating, .rating-text, .rating-count, [data-pdp-review-anchor]'
    );
    if (!trigger) return;
    scrollToReviews(e);
  });
})();
